const setAriaLabelledByToElement = (elementClassname, idToAssociate) => {
    const element = document.getElementsByClassName(elementClassname).item(0);
    if (element) {
        element.setAttribute("aria-labelledby", idToAssociate);
    }
};

export default setAriaLabelledByToElement;
